import {
  getTimes
  // getStudentExaminationList,
} from "@/api/student";
const examination = {
  state: {
    examinationInfo: null,
    countdownTime: 0,
    countdownSubmit: 0,
    raisecount: 60,
    startTime: 10 * 60 * 1000,
    endtime: 10 * 60 * 1000
    // isReload: false
  },
  mutations: {
    setExaminationInfo(state, obj) {
      state.examinationInfo = obj;
      console.log("进入时间", obj.startTime);
      if (obj != null) {
        getTimes().then(res => {
          let strtm = res.data.data;
          let currenttm = new Date(strtm).getTime();
          console.log("当前系统时间", currenttm);
          state.raisecount = 60;
          state.startTime = obj.startTime;
          state.endtime = obj.endtime;
          // 计算剩余秒数：(结束时间 - 当前时间) / 1000
          state.countdownTime = (obj.endtime - currenttm) / 1000;
          state.countdownSubmit = (obj.endtime - currenttm) / 1000;
        });
      } else {
        state.countdownTime = 0;
        state.countdownSubmit = 0;
      }
    },
    countdownTimeMinus(state) {
      // 一秒钟减一
      const raisecount = state.raisecount - 1;
      if (raisecount > 0) {
        state.raisecount = raisecount;
        if (state.countdownTime > 0) {
          state.countdownTime = state.countdownTime - 1;
        }
        if (state.countdownSubmit > 0) {
          state.countdownSubmit = state.countdownSubmit - 1;
        }
      } else {
        // 每 60 秒同步一次服务器时间
        getTimes().then(res => {
          let strtm = res.data.data;
          let currenttm = new Date(strtm).getTime();
          state.raisecount = 60;
          // 重新同步剩余秒数
          state.countdownTime = (state.endtime - currenttm) / 1000;
          state.countdownSubmit = (state.endtime - currenttm) / 1000;
        });
      }
    }
    //定义关闭界面刷新
    // reload(state, data) {
    //   state.isReload = data;
    // }
  },
  actions: {
    // setExaminationInfo(context){
    //   context.commit('setExaminationInfo')
    // }
  },
  getters: {
    countdown(state) {
      if (state.countdownTime < 0) {
        state.countdownTime = 0;
      }
      let min = Math.floor(state.countdownTime / 60);
      let second = Math.floor(state.countdownTime % 60);
      return (
        (min < 10 ? "0" + min : min) +
        ":" +
        (second < 10 ? "0" + second : second)
      );
    },
    enableSubmit(state) {
      return state.countdownSubmit > 0;
    }
  }
};
export default examination;
